import * as React from 'react';
import TextField from '@material-ui/core/TextField';

export default function renderInput(inputProps) {
  const {
    classes,
    autoFocus,
    value,
    ref,
    label,
    InputLabelProps,
    required,
    style = {},
    error,
    helperText,
    ...InputProps
  } = inputProps;

  return (
    <TextField
      autoFocus={autoFocus}
      className={classes.textField}
      error={error}
      required={required}
      label={label}
      InputLabelProps={InputLabelProps}
      value={value}
      inputRef={ref}
      style={style}
      helperText={helperText}
      InputProps={{
        classes: {
          input: classes.input
        },
        ...InputProps
      }}
    />
  );
}
